import { useState, useEffect, useContext, createContext } from 'react';
import { useFormContext } from './Provider';

const FormConditionalContext = createContext();

export const useFormConditionalContext = () => {
    return useContext(FormConditionalContext);
};

const Conditional = ({condition, children}) => {
    const {formData} = useFormContext();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(condition(formData));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const providerValues = {
        isVisible,
    };

    return (
        <FormConditionalContext.Provider value={providerValues}>
            <div className={isVisible ? 'flex flex-col gap-y-3' : 'hidden'}>
                {children}
            </div>
        </FormConditionalContext.Provider>
    );
}

const useConditionalHelper = (name) => {
    const { handleFieldVisibility } = useFormContext();
    const conditional = useFormConditionalContext();

    useEffect(() => {
        conditional && handleFieldVisibility(name, conditional.isVisible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conditional?.isVisible]); // Don't remove .isVisible - it'll get stuck in a loop
}

export default Conditional;

export {
    useConditionalHelper
}
